
import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as actions from '../../actionTypes'

export class Logger extends Component {

  constructor(props) {
    super(props)

    window.onerror = props.logError.bind(null, true)
  }

  render(){
    return this.props.children
  }
}

const mapDispatchToProps = dispatch => ({
  logError: (email, error, info) => {
    const action = {
      type: actions.LOG_ERROR,
      payload: {email, error, info}
    }

    dispatch(action)
  }
})

Logger.propTypes = {
  logError: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(Logger)


// WEBPACK FOOTER //
// ./src/components/common/logger.js